import PreviewAudioIcon from '../../icons/preview-audio.svg'
import PreviewGifIcon from '../../icons/preview-gif.svg'
import PreviewPhotoIcon from '../../icons/preview-photo.svg'
import PreviewVideoIcon from '../../icons/preview-video.svg'

export const MEDIA_TYPE_ICONS = {
  gif: { icon: <PreviewGifIcon />, label: 'GIF' },
  photo: { icon: <PreviewPhotoIcon />, label: 'Photo' },
  video: { icon: <PreviewVideoIcon />, label: 'Video' },
  audio: { icon: <PreviewAudioIcon />, label: 'Audio' },
  voice: {
    icon: <PreviewAudioIcon />,
    label: 'Voice Message',
  },
} as const
